import React from "react";
import "./LitterDensityInfoItem.scss";

export type LitterDensityInfoItemProps = {
  medianLitterDensity: number;
  maximumLitterDensity: number;
  minimumLitterDensity: number;
};

export const LitterDensityInfoItem: React.FC<LitterDensityInfoItemProps> = ({
  medianLitterDensity,
  maximumLitterDensity,
  minimumLitterDensity,
}) => {
  return (
    <div className="litter_density_info_item">
      <div className="title_section">
        <p className="title">Litter Density</p>
        <p className="title_description">Items Per 1000m2</p>
      </div>
      <div className="content_section">
        <div className="extremes_container">
          <p className="description">Low</p>
          <p className="value">{(minimumLitterDensity ?? 0).toLocaleString()}</p>
        </div>
        <div className="extremes_container">
          <p className="description">High</p>
          <p className="value">{(maximumLitterDensity ?? 0).toLocaleString()}</p>
        </div>
        <div className="extremes_container">
          <p className="description">Average</p>
          <p className="value">{(medianLitterDensity ?? 0).toLocaleString()}</p>
        </div>
      </div>
    </div>
  );
};
